import type { NDateLocale } from './enUS'
import { af } from 'date-fns/locale'

const dateAfZA: NDateLocale = {
  name: 'af-ZA',
  locale: af
}

export default dateAfZA
